import { useState } from 'react'
import { useAuthContext } from './useAuthContext'
import { showError, showSuccess } from '../utils/showPopup'

export const useLogin = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { setContextState } = useAuthContext()

    const login = async (email, password, employee_key) => {
        setIsLoading(true)

        const response = await fetch("/api/user/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password, employee_key})
        })

        const json = await response.json()
        
        if (!response.ok) {
            setIsLoading(false)
            showError(json.error)
        } else if (response.ok) {
            // spremi kao cookie
            localStorage.setItem("user", JSON.stringify(json))
            localStorage.setItem("api_key", json.api_key)

            // auth context
            setContextState({ type: "LOGIN", payload: json })
            showSuccess("Uspješno ste se prijavili!")
            setIsLoading(false)
            return true
        }
    }

    return { login, isLoading }
}
